export enum SORT_DIRECTIONS {
  ASC = "asc",
  DESC = "desc",
}
